import { MfsState } from './interfaces';
import { MfsStoreAction, SET_RATING_ID, SET_RATER_NOMINATION_DETAILS, SET_NEW_ADDED_RATER_ID } from './mfsAction';

export const mfsReducer = (state: MfsState, action: MfsStoreAction): MfsState => {
  switch (action.type) {
    case SET_RATING_ID:
      return { ...state, ratingId: action.payload };

    case SET_RATER_NOMINATION_DETAILS:
      return { ...state, raterNominationDetails: action.payload };

    case SET_NEW_ADDED_RATER_ID:
      return { ...state, newAddedRaterId: action.payload };

    default:
      return state;
  }
};
